export default __webpack_public_path__ + "static/media/banners_6.2500535d.png";